module.exports = "/static/assets/fb516154e603365f64d22b89fc08b8f8.png";